import { Skeleton } from "@caspeco/casper-ui-library";

const AlertSkeleton = () => {
    return <Skeleton w="100%" h="96px"></Skeleton>;
};

export default AlertSkeleton;
